import { createContext } from 'react';

export const AddTenantModalContext = createContext<{ open: () => void }>({ open: () => {} });
